<template>
  <section class="pb-2">
    <e-filters
      ref="filters"
      :title="$t('Filtros')"
      :searching="fetching"
      :search-text="$t('Consultar')"
      @search="getData"
      @reset="resetFilters"
    >
      <div>
        <b-row>
          <b-col md="6">
            <e-store-combo
              id="filters-store"
              v-model="filters.storeId"
              required
              @input="onChangeStore"
            />
          </b-col>

          <b-col md="6">
            <e-checking-account-combo
              v-model="filters.checkingAccountId"
              :type="['InternetBanking']"
              :store-id="filters.storeId"
              required
              active-options
              @input="setBalanceEmpty"
            />
          </b-col>
        </b-row>
      </div>
    </e-filters>

    <template v-if="balance">
      <b-row>
        <b-col
          md="4"
          class="mb-1"
        >
          <e-total-summary-card
            :title="$t('Saldo disponível')"
            title-class="text-success"
            :value="balance.availableAmount || 0"
          />
        </b-col>
        <b-col
          md="4"
          class="mb-1"
        >
          <e-total-summary-card
            :title="$t('Saldo bloqueado')"
            title-class="text-danger"
            :value="balance.blockedAmount || 0"
          />
        </b-col>
        <b-col
          md="4"
          class="mb-1"
        >
          <e-total-summary-card
            :title="$t('Aplicação automática')"
            title-class="text-info"
            :value="balance.automaticallyInvestedAmount || 0"
          />
        </b-col>
      </b-row>
      <p class="text-muted text-right">
        {{ $t('Consultado em') }}: {{ consultedAt | datetime('-', true) }}
      </p>
    </template>
  </section>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { BRow, BCol } from 'bootstrap-vue'
import { EStoreCombo, EFilters, ECheckingAccountCombo, ETotalSummaryCard } from '@/views/components'
import { alerts } from '@/mixins'

export default {
  components: {
    BRow,
    BCol,
    EStoreCombo,
    EFilters,
    ECheckingAccountCombo,
    ETotalSummaryCard,
  },

  mixins: [alerts],

  data() {
    return {
      fetching: false,
    }
  },

  computed: {
    ...mapState('pages/financial/internetBankingBalance', ['balance', 'consultedAt', 'filters']),
  },

  methods: {
    ...mapActions('pages/financial/internetBankingBalance', ['fetchBalance', 'resetFilters']),
    ...mapMutations('pages/financial/internetBankingBalance', ['SET_BALANCE']),

    async getData() {
      try {
        this.fetching = true
        await this.fetchBalance()
      } catch (error) {
        this.setBalanceEmpty()
        this.showGenericError({ error })
      } finally {
        this.fetching = false
      }
    },

    onChangeStore() {
      this.filters.checkingAccountId = null
      this.setBalanceEmpty()
    },

    setBalanceEmpty() {
      this.SET_BALANCE(null)
    },
  },
}
</script>

<style></style>
